import { __assign, __spreadArray } from "tslib";
export var chunk = function (arr, size) {
    return Array.from({ length: Math.ceil(arr.length / size) }, function (_element, i) { return arr.slice(i * size, i * size + size); });
};
export function createFillerArray(size) {
    size = size < 0 ? 0 : size;
    return Array.from(Array(size), function () { return null; });
}
/**
 * Filter an array by comparing the values of specific properties of each item in the array to a search query.
 * Returns a new array with the matching items.
 * @param {string} arr - The array to be searched.
 * @param {string} query - The query to search for in the array.
 * @param {string} {...props} - The array items' properties to be compared to the search query.
 */
export function search(arr, query) {
    var props = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        props[_i - 2] = arguments[_i];
    }
    var clone = arr.map(function (item) { return (__assign({}, item)); });
    var formattedQuery = query.toLowerCase();
    var matches = clone.filter(function (item) {
        for (var _i = 0, props_1 = props; _i < props_1.length; _i++) {
            var prop = props_1[_i];
            if (!item[prop] || typeof item[prop] !== 'string')
                continue; // skip item if invalid
            var formattedProp = item[prop].toLowerCase();
            if (formattedProp === formattedQuery)
                return true;
        }
    });
    var startsWith = clone.filter(function (item) {
        for (var _i = 0, props_2 = props; _i < props_2.length; _i++) {
            var prop = props_2[_i];
            if (!item[prop] || typeof item[prop] !== 'string')
                continue; // skip item if invalid
            var formattedProp = item[prop].toLowerCase();
            if (formattedProp.startsWith(formattedQuery))
                return true;
        }
    });
    var includes = clone.filter(function (item) {
        for (var _i = 0, props_3 = props; _i < props_3.length; _i++) {
            var prop = props_3[_i];
            if (!item[prop] || typeof item[prop] !== 'string')
                continue; // skip item if invalid
            var formattedProp = item[prop].toLowerCase();
            if (formattedProp.includes(formattedQuery))
                return true;
        }
    });
    return Array.from(new Set(__spreadArray(__spreadArray(__spreadArray([], matches, true), startsWith, true), includes, true)));
}
